export default __webpack_public_path__ + "9856da5e96ecc0a9158a19710af3b6d6.png";